import { installDevLogging } from "./devLogger";

installDevLogging({
  endpoint: "/api/dev/logs",
  enabled: Boolean((import.meta as unknown as { env?: { DEV?: boolean } }).env?.DEV ?? false)
});
